import { SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER, SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER } from "./urlParams"

export const TRAFFIC_API_VALUES = {
    [SPEEDINGS_HEAVY_VEHICLE_ACTIVE_LAYER]: "heavy_vehicle_count",
    [SPEEDINGS_LIGHT_VEHICLE_ACTIVE_LAYER]: "light_vehicle_count",
}